import React from 'react'
import { Box } from '@mui/material'
import { FeedbackTextCard } from '../../../feedbackGenerator/components'
import LatestFeedbackLayoutBox from '../../../feedbackGenerator/components/LatestFeedbackLayoutBox'
import { GlintRevealLayers } from '../../../feedbackGenerator/components/GlintRevealLayers'
import { useGlintRevealCover } from '../../../feedbackGenerator/hooks/useGlintRevealCover'
import type { DraftJsContent } from 'pure-js/libs/Common'

export interface GlintFeedbackTextSectionProps {
  /** Localized section title */
  title: string
  content: string | DraftJsContent
  /** Passed to FeedbackTextCard */
  variant: 'positive' | 'warning'
  showGlowExperience?: boolean
  onGlowExperienceComplete?: () => void
  onGlintStateChange?: (state: 'idle' | 'running') => void
}

/**
 * Shared “glass card + optional first-visit glint” wrapper for latest-session text sections.
 */
export const GlintFeedbackTextSection: React.FC<GlintFeedbackTextSectionProps> = ({
  title,
  content,
  variant,
  showGlowExperience = false,
  onGlowExperienceComplete,
  onGlintStateChange
}) => {
  const { containerRef, startReveal, layers } = useGlintRevealCover({
    isCovered: showGlowExperience,
    onRevealed: onGlowExperienceComplete,
    onGlintStateChange
  })

  return (
    <LatestFeedbackLayoutBox
      ref={containerRef}
      variant="individual"
      designVariant="standard"
      onMouseEnter={startReveal}
      onFocus={startReveal}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        width: '100%'
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: '100%',
          minHeight: { xs: 'auto', sm: '368px' }
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 0 }}>
          <FeedbackTextCard title={title} content={content} variant={variant} designVariant="standard" />
        </Box>

        <GlintRevealLayers {...layers} />
      </Box>
    </LatestFeedbackLayoutBox>
  )
}
